var _desc, _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDividerShadowOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "52px",
    viewBox: "0 0 14 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DividerShadowOverlay") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.4709201%",
    y1: "0%",
    x2: "45.4709202%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "50.1733897%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1up-Components-Worksheet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-72.000000, -1365.000000)",
    opacity: 0.100000001
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-Bar",
    transform: "translate(31.000000, 1264.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "step-bar",
    transform: "translate(0.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hover-Copy",
    transform: "translate(41.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "DividerShadowOverlay",
    points: "0 0 1 0 14 26.4300537 1 52 0 52 13 26.4300537"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "1up-Components-Worksheet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-201.000000, -1365.000000)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Step-Bar",
    transform: "translate(31.000000, 1264.000000)",
    fill: "#FCFCFC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "step-bar",
    transform: "translate(0.000000, 38.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hover",
    transform: "translate(81.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-13-Copy-3",
    points: "0 0 89 0 102 26.0529804 89 52 0 52 13 26.4328"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerShadowOverlay);
export default __webpack_public_path__ + "static/media/DividerShadowOverlay.fccad27b37c15a5bc8b639c5530e80ce.svg";
export { ForwardRef as ReactComponent };